import AbstractService from "./AbstractService";

export default class AbsenceRequestService extends AbstractService {
  url(url) {
    return `/absenceRequests${url}`;
  }

  createOne(request) {
    return this.http.post(this.url("/createOne"), request);
  }
  findAllUnderCharge(reference, query, include, embed, page, perPage, field, ascending) {
    const q = Object.assign({}, query);
  
    const params = this.getParams(
      q,
      include,
      embed,
      page,
      perPage,
      field,
      ascending
    );
    return this.http.get(this.url(`/underCharge/${reference}`), {
      params
    });
  }
  confirmRequest(reference, body) {
    return this.http.post(this.url(`/answer/${reference}`), body);
  }

  async validateLeave(reference, params) {
    const data = await this.http.get(this.url(`/validate/${reference}`), {
      params
    });
    return data;
  }

  _modelToQuery(model) {
    const query = Object.assign({}, model);
    return query;
  }
}
